import { useNavigate } from 'react-router-dom';
import CrudPage from './shared/CrudPage';
import { getLenguajes, createLenguaje, updateLenguaje, deleteLenguaje, uploadAdminFile } from '../../api/adminClient';

export default function AdminLenguajes() {
  const navigate = useNavigate();

  return (
    <CrudPage
      title="Accesos"
      idKey="ID"
      columns={[
        { key: 'ID', label: 'ID' },
        {
          key: 'icono',
          label: 'Icono',
          render: (v) => v
            ? <img src={v} alt="icono" className="w-10 h-10 rounded-lg object-cover border border-slate-200" />
            : <span className="text-slate-300 text-xs">—</span>,
        },
        {
          key: 'Descripcion',
          label: 'Descripción',
          primary: true,
          render: (v, row) => (
            <button
              type="button"
              onClick={() => navigate(`/admin/categorias?lenguajeId=${row.ID}`)}
              className="text-left font-semibold text-violet-700 hover:text-violet-900 hover:underline bg-transparent border-0 cursor-pointer p-0"
            >
              {v}
            </button>
          ),
        },
        { key: 'Textobtn', label: 'Texto botón' },
        { key: 'idioma',   label: 'Idioma' },
        { key: 'Orden',    label: 'Orden' },
      ]}
      fields={[
        { key: 'Descripcion', label: 'Descripción', required: true },
        { key: 'Textobtn',    label: 'Texto botón' },
        {
          key: 'idioma', label: 'Idioma', type: 'select', defaultValue: 'es',
          options: [
            { value: 'es', label: 'Español' },
            { value: 'en', label: 'English' },
          ],
        },
        {
          key: 'icono', label: 'Icono', type: 'image',
          onUpload: (file) => uploadAdminFile(file, 'lenguajes'),
        },
        { key: 'Orden', label: 'Orden', type: 'number', defaultValue: 0 },
      ]}
      fetchAll={getLenguajes}
      onCreate={createLenguaje}
      onUpdate={updateLenguaje}
      onDelete={deleteLenguaje}
    />
  );
}
